import { TmaAnalysisType } from '../models/TmaAnalysis/TmaAnalysis';
import { DescriptiveFormOption } from '../types';
import trans from './trans';

export const generateTmaAnalysisTypes = (isTmaExpert?: boolean): DescriptiveFormOption[] => ([
    {
        label: 'TMA 170',
        description: trans('forms.tmaAnalysisSettings.tma170Description'),
        value: TmaAnalysisType.TMA170,
        disabled: false,
    },
    {
        label: 'TMA 312',
        description: trans('forms.tmaAnalysisSettings.tma312Description'),
        value: TmaAnalysisType.TMA312,
        disabled: !isTmaExpert,
    },
]);
